import customTable from './components/custom-table.vue';

export default customTable;
